import {
  SET_LOADING_MF_OPTIONS,
  SET_MANUFACTURERS_DROPDOWN,
  SET_SUBMIT_LOADING,
  SET_PRODUCT_NAME,
  SET_SELECTED_MF,
  SET_STATUS
} from './constants';

const initialState = {
  manufacturerOptions: [],
  mfOptionsLoading: false,
  submitLoading: false,
  productName: '',
  selectedMFID: null,
  status: null
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_LOADING_MF_OPTIONS:
      return {
        ...state,
        mfOptionsLoading: action.optionsLoading
      };

    case SET_MANUFACTURERS_DROPDOWN:
      return {
        ...state,
        manufacturerOptions: action.options
      };

    case SET_SUBMIT_LOADING:
      return {
        ...state,
        submitLoading: action.submitLoading
      };

    case SET_PRODUCT_NAME:
      return {
        ...state,
        productName: action.productName
      };

    case SET_SELECTED_MF:
      return {
        ...state,
        selectedMFID: action.mfId
      };

    case SET_STATUS:
      return {
        ...state,
        status: action.status
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/Modules/CreateNewProduct/reducer.js